const REFERAL_ENDPOINTS = {
    // Search
    GET_REFERAL_INFO: "/frontend/referral-info",
    VALIDATE_REF_CODE: "/frontend/validate-referral-code",
    REF_LEADERBOARD: "frontend/referral-leaderboard"

};

export default REFERAL_ENDPOINTS;